module.exports = __webpack_public_path__ + "static/media/Down.0658d835.svg";